module.exports = ".price {\n  width: 200px;\n  text-align: center;\n  color: white;\n  background: #9B1C20; }\n\ntbody {\n  border: 20px solid transparent;\n  border-left: 0;\n  border-top: 0; }\n\ninput {\n  margin-top: 10px;\n  height: 1.6rem; }\n\n.description {\n  width: 90%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-rows: auto auto auto;\n      grid-template-rows: auto auto auto;\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/internet-cyberlink/internet-cyberlink.component.scss
// module id = ./src/app/content/new-offer/internet-cyberlink/internet-cyberlink.component.scss
// module chunks = main